export const debounce = (func: (...a: unknown[]) => unknown, delay: number) => {
  let inDebounce: NodeJS.Timeout | undefined = undefined

  return (...args: unknown[]) => {
    if (inDebounce) {
      clearTimeout(inDebounce)
    }

    return (inDebounce = setTimeout(() => func(...args), delay))
  }
}
